

































import Login from '@/components/common/Login.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

interface INavLink {
  name: string;
  href: string;
  isVisible?: () => boolean;
}

@Component({
  components: {
    Login,
  },
})
export default class Nav extends Vue {
  public isActive = false;
  public showBlog = process.env.VUE_APP_BLOG_ENABLED === 'true';
  public navItems: INavLink[] = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Campaigns', href: '/campaigns' },
    { name: 'Blog', href: '/blog', isVisible: () => this.showBlog },
  ];

  get displayNavItems() {
    return this.navItems.filter(item => !item.isVisible || item.isVisible());
  }

  public toggle() {
    this.isActive ? this.hide() : this.show();
  }

  public show() {
    this.isActive = true;
  }

  public hide() {
    this.isActive = false;
  }

  @Watch('$route')
  public onRouteChange() {
    this.hide();
  }
}
